export const sites = {
workspace: {
assets: "Activos",
sites: "Sitios",
},
list: {
  showAllSites: "Mostrar todos los sitios",
  emptyArchivedSub: "Los sitios que archivas se guardan aquí. Abre uno para restaurarlo.",
  emptyArchivedTitle: "No hay sitios archivados",
  queueArchived: "Archivados",
title: "Sitios",
subtitle_one: "{{count}} ubicación",
subtitle_other: "{{count}} ubicaciones",
searchPlaceholder: "Buscar sitios…",
searchA11y: "Buscar sitios",
refine: "Refinar",
refineSheetTitle: "Refinar sitios",
addSite: "Añadir sitio",
queueAll: "Todos",
queueAttention: "En riesgo",
queueDevelopment: "En desarrollo",
nextReviewAtRisk_one: "Revisar {{count}} activo en riesgo",
nextReviewAtRisk_other: "Revisar {{count}} activos en riesgo",
nextOpenJobs_one: "{{count}} trabajo abierto",
nextOpenJobs_other: "{{count}} trabajos abiertos",
nextOpenChecks_one: "{{count}} comprobación abierta",
nextOpenChecks_other: "{{count}} comprobaciones abiertas",
a11yAssets_one: "{{count}} activo",
a11yAssets_other: "{{count}} activos",
emptyTitle: "Todavía no hay sitios",
createSite: "Crear sitio",
emptySub: "Crea un sitio para agrupar activos por ubicación o cartera.",
emptyFilterTitle: "Ningún sitio coincide",
emptyFilterSub: "Prueba otros términos de búsqueda o borra los filtros.",
clearFilters: "Borrar filtros",
typeChip: "Tipo",
lifecycleChip: "Estado",
sortChip: "Ordenar",
sortNameAsc: "Nombre A–Z",
sortNameDesc: "Nombre Z–A",
sortNewest: "Más reciente",
sortOldest: "Más antiguo",
insightAttention: "{{count}} en riesgo",
nextAllClear: "Sin trabajo abierto",
nextAddAssets: "Añadir activos a este sitio",
pillAsset: "activo",
pillAssets: "activos",
pillOnTrack: "Al día",
pillJobs: "órdenes de trabajo",
pillChecks: "inspecciones",
exportCsv: "Exportar CSV",
exportCsvA11y: "Descargar sitios como CSV",
viewCards: "Vista de tarjetas",
viewTable: "Vista de tabla",
openSite: "Abrir sitio",
unassigned: "Sin asignar",
managingTeam: "Equipo gestor",
colSite: "Sitio",
colType: "Tipo",
colTeam: "Equipo",
colAssets: "Activos",
colJobs: "Trabajos",
colRisk: "En riesgo",
colStatus: "Estado",
unknownSite: "Sitio desconocido",
loadErrorTitle: "No pudimos cargar sus sitios",
loadErrorBlockedTitle: "No se pueden mostrar los sitios",
viewLabel: "Vista",
scopeLabel: "Ámbito",
csvHeaderName: "Nombre",
csvHeaderCode: "Referencia",
csvHeaderLifecycle: "Estado",
csvHeaderAddress: "Dirección",
subtitle_many: "{{count}} ubicaciones",
nextReviewAtRisk_many: "Revisar {{count}} activos en riesgo",
nextOpenJobs_many: "{{count}} trabajos abiertos",
nextOpenChecks_many: "{{count}} comprobaciones abiertas",
a11yAssets_many: "{{count}} activos",
},
detail: {
byPlaceTitle: "Por edificio",
byPlaceOpenA11y: "Abrir {{name}}",
byPlaceInside_one: "{{count}} dentro",
byPlaceInside_many: "{{count}} dentro",
byPlaceInside_other: "{{count}} dentro",
byPlaceOpenJobs_one: "{{count}} trabajo abierto",
byPlaceOpenJobs_many: "{{count}} trabajos abiertos",
byPlaceOpenJobs_other: "{{count}} trabajos abiertos",
byPlaceDue_one: "{{count}} visita pendiente",
byPlaceDue_many: "{{count}} visitas pendientes",
byPlaceDue_other: "{{count}} visitas pendientes",
byPlaceAtRisk_one: "{{count}} con riesgo alto",
byPlaceAtRisk_many: "{{count}} con riesgo alto",
byPlaceAtRisk_other: "{{count}} con riesgo alto",
  noWorkNoAssets: "El trabajo aparece aquí cuando este sitio tiene activos. Añade uno o mueve uno aquí.",
  assignSubtitleTeam: "Elige un activo para moverlo aquí. Sale de cualquier otro sitio y pasa a {{team}}.",
  assignSubtitle: "Elige un activo para moverlo aquí. Sale de cualquier otro sitio en el que esté.",
  assignFailedBody: "El activo no se ha movido. Comprueba la conexión e inténtalo de nuevo.",
  assignRefusedBody: "No puedes mover este activo. Pídeselo a quien lo gestiona o a un administrador.",
  assignFailedTitle: "Activo no movido",
  assignedFallbackAsset: "El activo",
  assignedToast: "{{asset}} se ha movido a {{site}}.",
  archivedBanner: "Este sitio está archivado y oculto en tus sitios. Restáuralo para volver a usarlo.",
  archivedPill: "Archivado",
  restoredToast: "{{name}} restaurado. Vuelve a estar en tus sitios.",
  archivedToast: "{{name}} archivado. Lo encontrarás en Archivados, en Sitios.",
loading: "Cargando sitio…",
addAsset: "Añadir activo",
createAsset: "Añadir activo",
assignAsset: "Asignar activo",
assignExistingAsset: "Asignar un activo existente",
siteOptions: "Opciones del sitio",
edit: "Editar",
tabOverview: "Resumen",
tabDetails: "Detalles",
tabAssets: "Activos",
tabWork: "Trabajo",
tabReports: "Informes",
tabEsg: "ESG",
tabContacts: "Contactos",
tabActivity: "Actividad",
tabPeople: "Personas",
refine: "Refinar",
view: "Vista",
viewList: "Lista",
viewMap: "Mapa",
viewNetwork: "Red",
filterAttention: "Necesita atención",
backToOverview: "Volver al resumen",
kpiAssets: "Activos",
kpiAtRisk: "En riesgo",
kpiOpenJobs: "Trabajos abiertos",
kpiOpenInspections: "Inspecciones abiertas",
parentSite: "Sitio principal",
childSites: "Sitios secundarios",
description: "Descripción",
noAssets: "No hay activos en este sitio.",
noAssetsForFilter: "Ningún activo coincide con este filtro.",
noWork: "No hay trabajos ni inspecciones abiertos.",
noContacts: "Todavía no hay contactos vinculados.",
noContactsNeedAssets: "Añade activos antes de vincular contactos.",
noActivity: "No hay actividad reciente.",
linkContact: "Vincular contacto",
selectAssetForContact: "Selecciona el activo para el contacto",
linkContactTitle: "Vincular contacto al activo del sitio",
cancel: "Cancelar",
filterAll: "Todos",
openJobs: "Trabajos abiertos",
openInspections: "Inspecciones abiertas",
attentionAssets_one: "{{count}} activo necesita atención",
attentionAssets_many: "{{count}} activos necesitan atención",
attentionAssets_other: "{{count}} activos necesitan atención",
openJobsCount_one: "{{count}} trabajo abierto",
openJobsCount_many: "{{count}} trabajos abiertos",
openJobsCount_other: "{{count}} trabajos abiertos",
assetsSectionTitle: "Activos en este sitio",
assetsSectionSub_one: "{{count}} activo",
assetsSectionSub_other: "{{count}} activos",
filterVehicles: "Vehículos",
descriptionSummary: "Notas y contexto del sitio",
workBannerNamed: "Trabajo limitado a {{names}}",
contactsForAsset_one: "{{count}} contacto",
contactsForAsset_other: "{{count}} contactos",
noContactsForAsset: "Todavía no hay contactos vinculados a este activo.",
archiveConfirmTitle: "¿Archivar este sitio?",
archiveConfirmMessage: "Se ocultará de tus sitios. Los activos se quedan donde están. Lo encontrarás en Archivados, en Sitios, para restaurarlo.",
archive: "Archivar",
archiveFailedTitle: "No se pudo archivar el sitio",
archiveFailedMessage: "El sitio no ha cambiado. Comprueba la conexión e inténtalo de nuevo.",
restore: "Restaurar sitio",
restoreFailedTitle: "No se pudo restaurar el sitio",
loadErrorTitle: "No pudimos cargar este sitio",
loadErrorBlockedTitle: "Este sitio no se puede mostrar",
goBack: "Volver",
notFoundTitle: "Sitio no encontrado",
notFoundBody: "Es posible que este sitio haya sido archivado o que el enlace no esté actualizado.",
noAssetsForSearch: "Ningún activo coincide con su búsqueda",
clearSearch: "Borrar búsqueda",
searchAssetsPlaceholder: "Buscar activos en este sitio",
kpiAttention: "Atención",
kpiOpenChecks: "Inspecciones abiertas",
kpiAssetsInfoDescription: "Activos asignados a este sitio. Los de sus sitios secundarios se cuentan en esos sitios.",
kpiAssetsInfoBasedOn_one: "{{count}} activo, contado en vivo desde el registro de activos",
kpiAssetsInfoBasedOn_many: "{{count}} activos, contados en vivo desde el registro de activos",
kpiAssetsInfoBasedOn_other: "{{count}} activos, contados en vivo desde el registro de activos",
kpiAttentionInfoDescription: "Activos en este sitio cuyo estado de salud es Vigilar o Malo, o que tienen trabajos atrasados.",
kpiAttentionInfoBasedOn: "{{count}} de {{total}} activos, según el estado de salud en tiempo real de cada activo",
kpiJobsInfoDescription: "Órdenes de trabajo en activos en este sitio que aún no se han completado ni verificado.",
kpiJobsInfoBasedOn_one: "{{count}} orden de trabajo abierta en {{total}} activos",
kpiJobsInfoBasedOn_many: "{{count}} órdenes de trabajo abiertas en {{total}} activos",
kpiJobsInfoBasedOn_other: "{{count}} órdenes de trabajo abiertas en {{total}} activos",
kpiChecksInfoDescription: "Inspecciones de activos en este sitio que aún están abiertas: iniciadas y no completadas, o programadas y aún no terminadas.",
kpiChecksInfoBasedOn_one: "{{count}} inspección abierta en {{total}} activos",
kpiChecksInfoBasedOn_many: "{{count}} inspecciones abiertas en {{total}} activos",
kpiChecksInfoBasedOn_other: "{{count}} inspecciones abiertas en {{total}} activos",
factsTitle: "Detalles",
factCode: "Código del sitio",
factCategory: "Categoría",
factType: "Tipo",
factStatus: "Estado",
factAddress: "Dirección",
factTeam: "Equipo responsable",
factContacts: "Contactos",
factHolds: "Contiene",
factCreated: "Creado",
factUpdated: "Actualizado",
factNotSet: "Sin definir",
factViewOnMap: "Ver en el mapa",
assetsSectionSub_many: "{{count}} activos",
contactsForAsset_many: "{{count}} contactos",
    tabDocuments: "Documentos",
    factFloorArea: "Superficie",
    floorAreaValue: "{{value}} m² de superficie",
},
map: {
  unavailableSub: "No se ha podido cargar el mapa. Comprueba la conexión e inténtalo de nuevo.",
  addSiteAddress: "Añadir la dirección del sitio",
noAssetsTitle: "No hay activos en este sitio",
noAssetsSub: "Añade activos para verlos en el mapa.",
noCoordinatesTitle: "Aún no hay nada en el mapa",
noCoordinatesSub: "Añade la dirección del sitio, o las de sus activos, para verlos aquí.",
unavailableTitle: "Mapa no disponible",
coverageShown_one: "Mostrando {{count}} activo con ubicación en el mapa.",
coverageShown_many: "Mostrando {{count}} activos con ubicación en el mapa.",
coverageShown_other: "Mostrando {{count}} activos con ubicación en el mapa.",
coverageHidden_one: "{{count}} oculto sin coordenadas.",
coverageHidden_many: "{{count}} ocultos sin coordenadas.",
coverageHidden_other: "{{count}} ocultos sin coordenadas.",
boundarySaveFailedTitle: "No se pudo guardar el límite",
boundarySaveFailedBody: "No se pudo guardar el contorno.",
boundaryRedraw: "Redibujar el límite",
boundaryDraw: "Dibujar límite",
boundaryRemove: "Quitar",
boundarySave: "Guardar límite",
boundaryUndo: "Deshacer",
boundaryTapFirstCorner: "Toca el mapa para colocar la primera esquina",
boundaryCornersAdjust: "{{count}} esquinas: arrastre cualquiera para ajustarla",
boundaryCornersOfThree: "{{count}} de 3 esquinas",
},
network: {
noAssetsTitle: "No hay activos para conectar",
noAssetsSub: "Añade al menos dos activos para explorar relaciones.",
singleAssetTitle: "Un activo en este sitio",
singleAssetSub: "Vincula este activo a otros desde su página de detalle para crear una red.",
openAsset: "Abrir activo",
},
assetLink: {
label: "Sitio",
helper: "El lugar donde está este activo.",
none: "Ningún sitio asignado",
open: "Abrir sitio",
rowHelper: "Opcional. El lugar donde está este activo.",
a11ySelected: "Sitio: {{name}}. Cambiar de sitio.",
a11yUnselected: "Seleccionar sitio, opcional",
clearSite: "Quitar sitio",
selectSite: "Seleccionar sitio",
},
kind: {
  status: {
    decommissioned: "Fuera de servicio",
    under_renovation: "En renovación",
    partially_operational: "Parcialmente en uso",
    operational: "En uso",
    handover: "En entrega",
    partially_developed: "Parcialmente construido",
    in_development: "En construcción",
    planned: "Previsto",
  },
  type: {
    other: "Otro",
    building: "Edificio",
    corridor: "Trazado (carretera, vía o tubería)",
    data_centre: "Centro de datos",
    hotel: "Hotel",
    hospital: "Hospital",
    airport: "Aeropuerto",
    shopping_centre: "Centro comercial",
    substation: "Subestación",
    project_site: "Emplazamiento de proyecto",
    construction_site: "Obra",
    parking_facility: "Aparcamiento",
    terminal: "Terminal",
    port: "Puerto",
    distribution_centre: "Centro de distribución",
    warehouse: "Almacén",
    workshop: "Taller",
    fleet_hub: "Centro de flota",
    garage: "Garaje",
    yard: "Patio",
    depot: "Depósito",
    plant: "Planta",
    factory: "Fábrica",
    industrial_park: "Polígono industrial",
    office_building: "Edificio de oficinas",
    campus: "Campus",
    retail_park: "Parque comercial",
    business_park: "Parque empresarial",
    scheme: "Promoción de viviendas",
    neighbourhood: "Barrio",
    estate: "Urbanización",
  },
  category: {
    other: "Otro",
    mixed_use: "Uso mixto",
    healthcare: "Sanidad",
    hospitality: "Hostelería",
    temporary: "Temporal / proyecto",
    infrastructure: "Infraestructura",
    logistics: "Logística y almacenaje",
    fleet_transport: "Flota y transporte",
    industrial: "Industrial",
    commercial: "Comercial",
    residential: "Residencial",
  },
  statusLabel: "Estado",
  typeLabel: "¿Cuál encaja mejor?",
  categoryLabel: "¿Qué tipo de lugar es?",
},
create: {
  createdBackToAsset: "{{name}} se ha creado y se ha elegido para tu activo.",
  created: "{{name}} se ha creado. Añade sus activos desde aquí.",
  unsavedGuardMessage: "No has guardado este sitio. ¿Salir y perder lo que escribiste?",
pageTitle: "Nuevo sitio",
newSiteKicker: "Nuevo sitio",
unnamedSite: "Sitio sin nombre",
addNotesFirstTitle: "Agregar notas primero",
addNotesFirstBody: "Escriba o dicte un borrador breve y luego utilice Mejorar con IA.",
improvedSiteNotesTitle: "Notas del sitio mejoradas",
unableToImproveNotesTitle: "No se pueden mejorar las notas",
improveNotesRationale: "Revise las notas mejoradas antes de aplicarlas al sitio.",
improveNotesFailed: "No se pudieron mejorar las notas. Por favor inténtalo de nuevo.",
nameRequiredTitle: "Se requiere un nombre",
nameRequiredBody: "Escribe un nombre para el sitio.",
invalidTypeTitle: "Vuelve a elegir el tipo",
invalidTypeBody: "Ese tipo no encaja con el tipo de lugar elegido. Elige uno de la lista.",
createFailedTitle: "No se pudo crear el sitio",
createFailedBody: "El sitio no se ha creado. Comprueba la conexión e inténtalo de nuevo.",
labelType: "Tipo de sitio",
labelLifecycle: "Estado",
labelParent: "Sitio principal",
labelManagingTeam: "Equipo gestor",
labelAddress: "Dirección",
labelName: "Nombre",
labelCode: "Referencia",
fallbackDash: "—",
basicsNameLabel: "Nombre *",
siteNameA11y: "Nombre del sitio (obligatorio)",
siteNamePlaceholder: "p. ej., Finca Oakwood",
codeLabel: "Referencia (opcional)",
codeHint: "Tu código corto para este sitio, si usas uno.",
codeA11y: "Referencia (opcional)",
codePlaceholder: "p. ej. NDEP-01",
parentSiteLabel: "Sitio principal",
parentSiteHelper: "Opcional. Colócalo dentro de una urbanización, un depósito o un campus.",
managingTeamHelper: "Los activos que añadas a este sitio pasan a este equipo.",
addressLabel: "Dirección (opcional)",
descriptionLabel: "Descripción (opcional)",
descriptionA11y: "Descripción (opcional)",
descriptionPlaceholder: "Notas de acceso, detalles de la fase o contexto de la entrega",
dictate: "Dictar",
stopDictation: "Detener",
improving: "Mejorando...",
improveWithAi: "Mejora con IA",
stepBasicsTitle: "Lo básico",
stepBasicsWhy: "Pon un nombre al sitio. Es lo único necesario; lo demás es opcional.",
stepLocationTitle: "¿Dónde está?",
stepLocationWhy: "Añade la dirección para que la gente pueda encontrarlo.",
stepClassifyTitle: "Tipo de sitio",
stepClassifyWhy: "Indica qué tipo de lugar es y si está en uso.",
stepStructureTitle: "Sitio principal y equipo",
stepStructureWhy: "Colócalo dentro de un sitio más grande y elige el equipo que se encarga de él.",
saving: "Guardando…",
createSite: "Crear sitio",
parentSiteModalTitle: "Sitio principal",
managingTeamModalTitle: "Equipo gestor",
},
team: {
managingTeam: "Equipo gestor",
managingTeamHelper: "Los activos de este sitio heredan este equipo al añadirse o cuando lo cambias aquí.",
selectTeam: "Seleccionar equipo",
optional: "Opcional",
pickerTitle: "Equipo gestor",
noneAssigned: "Ningún equipo asignado",
cascadeConfirmTitle: "¿Actualizar los equipos de los activos?",
cascadeConfirmMessage_one: "{{count}} activo de este sitio se reasignará a {{team}}.",
cascadeConfirmMessage_other: "{{count}} activos de este sitio se reasignarán a {{team}}.",
cascadeConfirmAction: "Actualizar equipo",
updateFailedTitle: "No se ha podido actualizar el equipo",
updateFailedMessage: "Inténtalo de nuevo.",
rowHelper: "Los activos agregados a este sitio heredan esta asignación de equipo.",
a11ySelected: "Equipo gestor: {{name}}. Cambiar de equipo.",
a11yUnselected: "Seleccionar equipo gestor, opcional",
clearTeam: "Quitar equipo",
cascadeConfirmMessage_many: "{{count}} activos de este sitio se reasignarán a {{team}}.",
},
picker: {
dismissA11y: "Descartar el selector de sitios",
closeA11y: "Cerrar selector de sitio",
searchPlaceholder: "Buscar sitios...",
loadingSites: "Cargando sitios",
emptyResults: "No se encontraron sitios. Crea uno a continuación o cancela para volver.",
selectItemA11y: "Seleccione {{name}}",
},
report: {
placeTitle: "{{place}} · {{site}}",
  generateFailedBody: "Algo ha fallado. Inténtalo de nuevo en un minuto.",
  shareFailedTitle: "No se pudo guardar el informe",
  shareGenerated: "Redactado por IA el {{date}}. Revíselo antes de confiar en él.",
  shareTitle: "Informe del sitio: {{name}}",
  pdfDocType: "Informe del sitio",
  pdfSummary: "Resumen del sitio",
  pdfType: "Tipo de sitio",
  pdfStatus: "Estado",
  pdfTeam: "Equipo responsable",
  pdfAddress: "Dirección",
  pdfAssetCount: "Activos",
  pdfAssetsHeading: "Activos en este sitio",
  pdfColAsset: "Activo",
  pdfColType: "Tipo de activo",
  pdfColStatus: "Estado",
  sharePdf: "Guardar o compartir en PDF",
  internetResearchHint: "Desactivado: el informe solo usa sus registros. Activado: también busca en la web, por ejemplo retiradas de esta marca y modelo.",
  internetResearchA11y: "Buscar también información pública en internet",
  internetResearch: "Buscar también información pública en internet",
loadHistoryFailedTitle: "No se puede cargar el historial del informe",
unknownError: "Error desconocido",
selectAnalysisTypeTitle: "Seleccione al menos un tipo de análisis",
selectAnalysisTypeBody: "Elige una o más secciones antes de generar el informe.",
generateFailedTitle: "No se generó el informe del sitio",
summaryPlaceholder: "Genere o cargue un informe avanzado del sitio para ver el riesgo, el estado, el cumplimiento y las recomendaciones de la cartera en cada activo de este sitio.",
actionSelectType: "Seleccione al menos un tipo de análisis.",
actionGenerate: "Genere el informe del sitio.",
analysisSiteOverview: "Descripción general del sitio",
analysisAssets: "Activos",
analysisMaintenance: "Mantenimiento",
analysisRisk: "Riesgo",
analysisHealth: "Salud",
analysisCompliance: "Cumplimiento",
analysisComparisons: "Comparaciones",
contextBadge: "Informe con IA",
fallbackTitle: "Informe del sitio",
metaKind: "Informe con IA",
heroTitle: "Generar informe del sitio",
heroSub: "La IA redacta un informe con cada activo de este sitio: inspecciones, trabajos, documentos y riesgos.",
includeAnalysis: "Incluir análisis",
toggleAnalysisA11y: "Alternar análisis {{label}}",
generateButton: "Generar informe",
snapshotComparison: "Informes anteriores",
latestSnapshotLine: "Último: {{date}}",
previousSnapshotLine: "Anterior: {{date}}",
noPreviousSnapshot: "Aún no hay informes anteriores.",
insightTitle: "Resumen del informe del sitio",
signalRisk: "El riesgo es {{level}} ({{score}}).",
signalHealth: "La salud es {{status}} ({{score}}).",
signalCompliance: "El cumplimiento es {{posture}} ({{score}}).",
signalLatestSnapshot: "Último informe guardado: {{date}}.",
signalNoSnapshot: "Aún no se ha guardado ningún informe.",
signalAnalysisSelected_one: "Se ha seleccionado {{count}} tipo de análisis.",
signalAnalysisSelected_other: "Se han seleccionado {{count}} tipos de análisis.",
signalSnapshotsAvailable_one: "Hay {{count}} informe guardado disponible.",
signalSnapshotsAvailable_other: "Hay {{count}} informes guardados disponibles.",
signalNoSnapshotsAvailable: "Aún no hay informes guardados.",
metricSnapshots: "Informes guardados",
sourceGenerated: "Redactado por IA",
sourceSnapshot: "Último informe guardado",
sourceSetup: "Aún no generado",
executiveSummary: "Resumen ejecutivo",
riskHealthCompliance: "Riesgo / salud / cumplimiento",
riskLine: "Riesgo: {{level}} ({{score}})",
healthLine: "Salud: {{status}} ({{score}})",
complianceLine: "Cumplimiento: {{posture}} ({{score}})",
maintenanceService: "Mantenimiento y servicio",
recommendations: "Recomendaciones",
recommendationLine: "- {{recommendation}}",
noReportYet: "Aún no hay informe del sitio. Toque Generar informe.",
sources: "Fuentes",
sourceLine: "- [{{sourceType}}] {{title}}",
signalAnalysisSelected_many: "Se han seleccionado {{count}} tipos de análisis.",
signalSnapshotsAvailable_many: "Hay {{count}} informes guardados disponibles.",
},
edit: {
  parentLoopBody: "Un sitio no puede estar dentro de sí mismo ni de uno de sus propios sitios.",
  parentLoopTitle: "Elige otro sitio",
  updateFailedBody: "Tus cambios no se han guardado. Comprueba la conexión e inténtalo de nuevo.",
  saved: "{{name}} guardado.",
pageTitle: "Editar sitio",
unsavedGuardMessage: "Tiene cambios sin guardar en este sitio. ¿Salir y perderlos?",
unsavedGuardDiscard: "Salir",
unsavedGuardKeep: "Sigue editando",
updateFailedTitle: "No se pudo actualizar el sitio",
loadErrorTitle: "No se pudo cargar este sitio",
loadErrorWithMessage: "{{message}}. Comprueba tu conexión y vuelve a intentarlo.",
loadErrorGeneric: "Comprueba tu conexión y vuelve a intentarlo.",
save: "Guardar",
archiveConfirmMessage: "Se ocultará de tus sitios. Los activos se quedan donde están. Lo encontrarás en Archivados, en Sitios, para restaurarlo.",
siteNameA11y: "Nombre del sitio",
codeA11y: "Código",
descriptionA11y: "Descripción",
archiveSite: "Archivar sitio",
    floorArea: "Superficie (m²)",
    floorAreaPlaceholder: "p. ej., 2400",
    floorAreaHint: "Se usa en ESG para la energía y el carbono por m². Déjelo en blanco si no lo sabe.",
    floorAreaInvalid: "Introduzca la superficie como un número de metros cuadrados.",
},
intake: {
pageTitle: "Informar un problema",
errorTitleMissing: "Cuéntanos qué está pasando.",
errorDescriptionMissing: "Agregue algunos detalles para que el equipo pueda ayudar.",
errorNameMissing: "Su nombre es obligatorio.",
errorEmailInvalid: "Introduzca un correo electrónico válido.",
errorPhoneInvalid: "Ingrese un número de teléfono válido para el país seleccionado.",
errorContactMissing: "Agregue un correo electrónico o un teléfono para que el equipo pueda responder.",
uploadFailed: "No pudimos subir sus fotos. Quítelas o inténtelo de nuevo.",
errorNotAvailable: "Este enlace no acepta solicitudes en este momento.",
errorSubmitterDetailsRequired: "Agregue su nombre y un correo electrónico o número de teléfono.",
errorSubmitGeneric: "No pudimos enviar su solicitud. Inténtelo de nuevo.",
contactLabel: "Contacto",
addressLabel: "Dirección",
linkIncompleteTitle: "Enlace incompleto",
linkIncompleteBody: "Al enlace que abrió le falta la referencia del activo. Intente escanear el código QR nuevamente.",
unavailableTitle: "Este enlace no acepta solicitudes",
unavailableBody: "Los avisos están desactivados para este código o el código ya no es válido. Avisa a quienes se ocupan del lugar, por ejemplo recepción o la oficina.",
sentTitle: "Gracias, lo tenemos.",
sentBody: "{{company}} ha recibido tu aviso. Te contactarán por correo o teléfono si necesitan algo. Puedes cerrar esta página.",
fallbackTeam: "El equipo",
reportAnother: "Informar de otro problema",
reportAnotherA11y: "Informar otro problema en este activo",
beforeYouSend: "Antes de enviar",
deflectTitle: "Esto podría solucionarlo más rápido",
deflectIntro_one: "Hemos encontrado una guía para este activo que podría resolver ya su problema. Échele un vistazo rápido: si le ayuda, listo. Si no, envíe su solicitud a continuación.",
deflectIntro_other: "Hemos encontrado {{count}} guías para este activo que podrían resolver ya su problema. Écheles un vistazo rápido: si le ayudan, listo. Si no, envíe su solicitud a continuación.",
kbFaq: "PREGUNTAS FRECUENTES",
kbHowTo: "CÓMO HACER",
collapseGuideA11y: "Contraer {{title}}",
expandGuideA11y: "Ampliar {{title}}",
openFullGuide: "Abrir la guía completa",
openGuideA11y: "Abrir guía: {{title}}",
stillSend: "Enviar mi solicitud igualmente",
stillSendA11y: "Enviar mi solicitud de todos modos",
backToRequest: "Volver a mi solicitud",
backToRequestA11y: "Volver para editar mi solicitud",
formTitle: "Cuéntanos qué está pasando",
introWithAsset: "Estás informando un problema con {{assetName}}. ",
introBody: "El equipo verá su mensaje y se comunicará con usted; agregue su nombre y un correo electrónico o teléfono para que puedan comunicarse con usted.",
fieldWhatsHappening: "¿Qué está pasando?",
titlePlaceholder: "Resumen en una línea, p. ej. 'no hay agua caliente en la unidad 3'",
titleA11y: "¿Qué está pasando? (obligatorio)",
fieldDetails: "Detalles",
detailsPlaceholder: "Describe el problema: qué falla, dónde y desde cuándo",
detailsA11y: "Detalles (obligatorio)",
fieldPhotos: "Fotos",
photosOptionalHint: "(opcional, hasta 2)",
removePhotoA11y: "Eliminar foto {{index}}",
addPhotoA11y: "Añadir una foto",
addPhotoLabel: "Añadir foto",
fieldYourName: "Tu nombre",
namePlaceholder: "Para que sepan a quién están ayudando",
nameA11y: "Tu nombre (obligatorio)",
fieldEmail: "Correo electrónico",
emailPlaceholder: "Para que puedan responder",
fieldPhone: "Teléfono",
phonePlaceholder: "En caso de que necesiten llamar",
contactHint: "Solo usaremos esto para responder sobre tu informe.",
sending: "Enviando…",
checkingFix: "Buscando una solución rápida...",
sendRequest: "Enviar solicitud",
deflectIntro_many: "Hemos encontrado {{count}} guías para este activo que podrían resolver ya su problema. Écheles un vistazo rápido: si le ayudan, listo. Si no, envíe su solicitud a continuación.",
},
knowledge: {
  goToAssets: "Ir a activos",
backButton: "Atrás",
title: "Conocimiento",
subtitle: "Busque en sus activos",
unknownAsset: "Activo desconocido",
anyAsset: "Cualquier activo",
moreAssetsSummary: "{{first}}, {{second}} +{{count}} más",
openItemA11y: "Abrir {{title}}, {{kind}} en {{asset}}",
untitledItemA11y: "elemento de conocimiento",
untitled: "Sin título",
searchPlaceholder: "Buscar en el conocimiento",
refineResults: "Refinar resultados",
refineTypeLabel: "Tipo",
refineAssetLabel: "Activo",
assetSummaryA11y: "Activo: {{summary}}",
removeAssetA11y: "Quitar {{name}}",
signInTitle: "Inicia sesión para buscar tus conocimientos",
signInBody: "Tu sesión ha caducado, así que no se pudo buscar nada. Vuelve a iniciar sesión para continuar.",
searchErrorTitle: "No se pudo ejecutar esa búsqueda",
tryAgain: "Intentar de nuevo",
noMatchesTitle: "No hay coincidencias",
noMatchesBody: "Sin resultados. Pruebe otras palabras o añádalo: abra el activo, vaya a Conocimiento y toque Añadir.",
noFilterMatchesTitle: "Nada coincide con estos filtros",
filteredEmptyBody_one: "{{count}} resultado coincidió con la búsqueda, pero ninguno coincide con el activo o el tipo que eligió.",
filteredEmptyBody_other: "{{count}} resultados coincidieron con la búsqueda, pero ninguno coincide con el activo o el tipo que eligió.",
introTitle: "Busque en su base de conocimientos",
introBody: "Encuentre guías, preguntas frecuentes, notas, archivos y enlaces de todos los activos. Escriba al menos dos letras. Para añadir conocimiento, abra un activo, vaya a Conocimiento y toque Añadir.",
shareOpenLinkFailedTitle: "No se pudo abrir el enlace",
shareInvalidLink: "Enlace no válido",
shareTimeoutMessage: "Esta biblioteca compartida está tardando demasiado en cargarse. Comprueba tu conexión y vuelve a intentarlo.",
shareLoadFailed: "No se pudo cargar el conocimiento compartido",
shareUnableToLoad: "No se puede cargar",
shareEmptyTitle: "Nada que mostrar",
shareEmptyBody: "Es posible que este recurso compartido haya sido revocado o que aún no se hayan publicado artículos.",
shareOpenLink: "Abrir enlace",
shareOpenFile: "Abrir archivo",
shareClose: "Cerrar",
filteredEmptyBody_many: "{{count}} resultados coincidieron con la búsqueda, pero ninguno coincide con el activo o el tipo que eligió.",
},
  documents: {
    title: "Documentos de la ubicación",
    sub: "Documentos de todo el edificio, como su EPC o DEC. Los documentos de cada activo se quedan en el activo.",
    add: "Añadir documento",
    open: "Abrir",
    edit: "Editar",
    archive: "Archivar",
    cancel: "Cancelar",
    archiveTitle: "¿Archivar este documento?",
    archiveBody: "{{title}} sale de esta lista. Se conservan su archivo y su historial.",
    archiveFailed: "No se pudo archivar el documento. Inténtelo de nuevo.",
    loadFailed: "No se pudieron cargar los documentos.",
    retry: "Reintentar",
    emptyTitle: "Aún no hay documentos de la ubicación",
    emptyBody: "Añada aquí los certificados del edificio, como su EPC o DEC.",
    validUntil: "Válido hasta el {{date}}",
    expired: "Caducado el {{date}}",
  },
};
